import { useEffect, useState } from "react";


export function useOnClient(): boolean {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(
            typeof window !== "undefined"
            && typeof document !== "undefined",
        );
    }, []);
    return isClient;
}
